import React from "react";

// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import {withStyles} from "@material-ui/core/styles";

// @material-ui/icons

// core components
import Header from "components/Header/Header.jsx";
import speakerPageStyle from "../../../assets/jss/material-kit-react/views/speakerPage";
import Parallax from "../../../components/Parallax/Parallax";
import HeaderLinks from "../HeaderLinks";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import Footer from "../Sections/Footer";
import {List, ListItem, Table, TableBody, TableCell, TableRow} from "@material-ui/core";
import {Movie} from "@material-ui/icons";

import {Speaking} from "../../../database/dictionary";
import Muted from "../../../components/Typography/Muted";

class SpeakerPage extends React.Component {
    render() {
        const {classes, ...rest} = this.props;
        return (
            <div className={classNames(classes.root)}>
                <Header
                    color="transparent"
                    brand="HOME"
                    rightLinks={<HeaderLinks/>}
                    fixed
                    changeColorOnScroll={{
                        height: 100,
                        color: "white"
                    }}
                    {...rest}
                />
                <Parallax small image={require("assets/img/developer-bg.jpg")}>
                    <div className={classes.container}>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={6}>
                                <h1 className={classNames(classes.title, classes.textCenter)}>My presentations</h1>
                            </GridItem>
                        </GridContainer>
                    </div>
                </Parallax>
                <div className={classNames(classes.main)}>
                    <div className={classes.container}>
                        <GridContainer>
                            {
                                Speaking.map(year =>
                                    <GridItem xs={12} key={year.year}>
                                        <List>
                                            <ListItem><h2>{year.year}</h2></ListItem>
                                            <Table>
                                                <TableBody>
                                                    {
                                                        year.items.map(item =>
                                                            <TableRow key={item.place}>
                                                                <TableCell className={classes.listDate}>
                                                                    <Muted>{item.date}</Muted>
                                                                </TableCell>
                                                                <TableCell>
                                                                    <i className={classes.listTopic}>{item.topic}</i>
                                                                    {item.video ?
                                                                        <a className={classes.icon} href={item.video}>
                                                                            <Movie/>
                                                                        </a>
                                                                        : <div/>
                                                                    }
                                                                </TableCell>
                                                                <TableCell>
                                                                    <a
                                                                        href={item.link ? item.link : ""}
                                                                        target="_blank">{item.place}</a>
                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                    }
                                                </TableBody>
                                            </Table>
                                        </List>
                                    </GridItem>
                                )
                            }
                        </GridContainer>
                    </div>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default withStyles(speakerPageStyle)(SpeakerPage);


// WEBPACK FOOTER //
// ./src/views/LandingPage/pages/SpeakerPage.jsx